export default "__VITE_ASSET__CBwtoy_a__"